import GroupService from '@/services/GroupService';

const groups = {
    state: {
        groups: []
    },
    mutations: {
        ['SET_GROUPS'] (state, groups) {
            state.groups = groups;
        }
    },
    actions: {
        ['RETRIEVE_GROUPS'] ({commit}) {
            GroupService.get(groups => {
                commit('SET_GROUPS', groups);
            });
        },
    },
    getters: {
        groups: state => {
            return state.groups;
        }
    }
};

export default groups;


// WEBPACK FOOTER //
// ./src/store/modules/groups.js